import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import Icon from '../../../icon'
import Card from '../../card'

import ArrowLeft from '../../../icon/arrow-left.svg'

const ListingList = ({ items, resources, resourceKind, backgroundColor, backgroundIconColor, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'md:pt-24',
      'md:pb-12',
      'pt-20',
      'pb-10'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4',
          'mb-10'
        ])
      }>
      <Link
        href="/recursos">
        <a
          className={
            classNames(
              [
                'text-green-500'
              ]
            )
          }>
          <Icon
            size={24}
            width={24}
            height={24}
            svg={ArrowLeft}
            className="mr-2 inline-block" />
          {' '}Volver atrás
        </a>
      </Link>
    </div>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4',
          'mb-10'
        ])
      }>
      <div
        className={
          classNames(
            [
              'grid',
              'grid-cols-1',
              'sm:grid-cols-2',
              'lg:grid-cols-3',
              'gap-8'
            ]
          )
        }>
        {
          (items || resources || []).map(
            (item, index) => {
              return (
                <Card
                  key={`listing-${index + 1}`}
                  resource={item} />
              )
            })
        }
      </div>
    </div>
  </section>
}

ListingList.propTypes = {
  items: PropTypes.array,
  resources: PropTypes.array,
  resourceKind: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundIconColor: PropTypes.string
}

export default ListingList
